






















































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'
import { uuid, isOnline, localForage } from '../../../utils/services'
import { camelCase, findIndex, findLastIndex, countBy, flow, method } from 'lodash'
import manholeSchema from '../../data/schema-wastewater-manhole'
import inflowSchema from '../../data/schema-wastewater-inflow'
import stormSchema from '../../data/schema-stormwater-manhole'
import Survey from '../../../class/survey'
import Upload from '../../../class/upload'

@Component({
    inject: ['$validator'],
    components: {
        layoutSection: () => import('../../components/shared/LayoutSection.vue'),
        cardTabbed: () => import('../../components/shared/CardTabbed.vue'),
        expansionPanel: () => import('../../components/shared/ExpansionPanel.vue'),
        vDropzone: () => import('../../components/shared/VDropzone.vue'),
        vueUpload: () => import( /* webpackChunkName: "vueUpload" */ '../../components/shared/VueUpload.vue'),
    },
    async beforeRouteLeave (to : any, from : any, next : any) {
        // @ts-ignore - yes ts, this is a property on the component!
        if(this.dirty) {
          if (window.confirm('Do you really want to leave? You have unsaved changes!')) {
            window.onbeforeunload = null
            next()
          } else {
            next(false)
          }
        } else {
            next()
        }
    }
})

export default class Manhole extends Vue {

    surveySchema: any = {}
    expand: any = null
    headerValues: any = {}
    dirty : boolean = false
    uploadedFiles: Array<object> = []
    pendingFiles: Array<any> = []
    invalidFiles: Array<any> = []
    duplicateFiles: Array<any> = []
    ids: any = {}
    showInvalidDialog: boolean = false
    isMounted: boolean = false

    parentPage = 'cctvmain'

    fileData:any = [];
    fileCount = 0;

    @Prop(Object) network!: any

    @Watch('fields', { deep: true })
    onChange(newValue: any, oldValue: any) {
        this.dirty = Object.keys(this.fields).some(key => (this.fields[key].dirty || !this.fields[key].pristine));
    }

    @Watch('$route', { immediate: true })
    onRouteChanged(newRoute: any, oldRoute: any) {
        // Handle route changes to ensure data loading works properly
        const edittarget = newRoute.query.uuid as string;
        if (edittarget && (!oldRoute || oldRoute.query.uuid !== edittarget)) {
            // Wait for component to be mounted before loading data
            if (this.isMounted) {
                this.loadEditDataSafely(edittarget);
            } else {
                // Component not mounted yet, wait for it
                this.$nextTick(() => {
                    // Wait a bit more to ensure everything is initialized
                    setTimeout(() => {
                        // Double-check if component is still not mounted
                        if (!this.isMounted) {
                            // Force mount completion and then load data
                            this.isMounted = true;
                        }
                        this.loadEditDataSafely(edittarget);
                    }, 150);
                });
            }
        }
    }

    doHeader(e: any, p: any) {
        p.item.value = e.parent + ' - ' + e.name
    }

    doCombinedHeader(event: any, section: any, props: any) {
        event.index = parseInt(event.index)

        // we need to track the value for each section seperately
        const sectionName = section.name + '/' + props.item.name + '/' + props.index
        if(!this.headerValues[sectionName]) {
            // @ts-ignore
            this.headerValues[sectionName] = [];
        }

        let headerVals: string[] = this.headerValues[sectionName];

        if(event.index >= headerVals.length) {
            for(let i = headerVals.length - 1; i < event.index; i++) {
                headerVals.push('')
            }
        }
        headerVals[event.index] = event.value

        // note that we don't want to modify headervalues here - otherwise we would not be able
        // to replace the exact element we are updating
        props.item.value = headerVals.filter( i => i !== '').join(' - ')
    }

    mounted() {
        modules.root.hideFab()
        
        // Only start geolocation watch if not editing an existing survey
        const edittarget = this.$route.query.uuid as string;
        if (!edittarget) {
            modules.browser.geolocationWatch()
        }

        // Deep clone the schema to prevent contamination between instances
        if( this.$route.fullPath.indexOf('wastewater') > -1 && this.$route.fullPath.indexOf('manhole') > -1 ) {
            this.surveySchema = JSON.parse(JSON.stringify(manholeSchema));
        }
        if( this.$route.fullPath.indexOf('wastewater') > -1 && this.$route.fullPath.indexOf('inflow-inspection') > -1 ) {
            this.surveySchema = JSON.parse(JSON.stringify(inflowSchema));
        }
        if( this.$route.fullPath.indexOf('stormwater') > -1 && this.$route.fullPath.indexOf('manhole') > -1 ) {
            this.surveySchema = JSON.parse(JSON.stringify(manholeSchema));
        }

        // Reset component state
        this.fileData = [];
        this.fileCount = 0;
        this.pendingFiles = [];
        this.headerValues = {};

        // Initialize fresh schema for new survey (will be overridden by route watcher if editing)
        this.initializeFreshSchema();

        // TODO - fix this when we add water supply forms
        if(this.$route.fullPath.indexOf('wastewater') > -1) {
            this.parentPage = 'wwmain'
        } else {
            this.parentPage = 'swmain'
        }
        window.onbeforeunload = () => "You have unsaved changes!";
        
        // Mark component as fully mounted
        this.isMounted = true;
    }

    // Ensure schema is initialized before loading data
    ensureSchemaInitialized() {
        if (!this.surveySchema || !this.surveySchema.sections) {
            // Deep clone the schema to prevent contamination between instances
            if( this.$route.fullPath.indexOf('wastewater') > -1 && this.$route.fullPath.indexOf('manhole') > -1 ) {
                this.surveySchema = JSON.parse(JSON.stringify(manholeSchema));
            }
            if( this.$route.fullPath.indexOf('wastewater') > -1 && this.$route.fullPath.indexOf('inflow-inspection') > -1 ) {
                this.surveySchema = JSON.parse(JSON.stringify(inflowSchema));
            }
            if( this.$route.fullPath.indexOf('stormwater') > -1 && this.$route.fullPath.indexOf('manhole') > -1 ) {
                this.surveySchema = JSON.parse(JSON.stringify(manholeSchema));
            }
        }
    }

    // Safe method to load edit data with proper initialization
    loadEditDataSafely(edittarget: string, retryCount: number = 0) {
        if (!edittarget) return;

        // Ensure schema is initialized before loading data
        this.ensureSchemaInitialized();
        
        // Reset component state before loading new data
        this.fileData = [];
        this.fileCount = 0;
        this.pendingFiles = [];
        this.headerValues = {};

        // Initialize fresh schema first
        this.initializeFreshSchema();

        // Load both files and survey data, then process
        Promise.all([
            localForage.getFilesItem(edittarget),
            localForage.getSurveyItem(edittarget)
        ]).then(([filesRes, surveyRes]) => {
            // Process survey data first to set up form structure
            if (surveyRes) {
                this.loadSurveyData(surveyRes);
            }
            
            // Then load files
            if (filesRes) {
                this.loadSurveyFiles(filesRes);
            }
        }).catch(error => {
            // Error loading survey data - retry once if it's the first attempt
            if (retryCount < 1) {
                setTimeout(() => {
                    this.loadEditDataSafely(edittarget, retryCount + 1);
                }, 300);
            }
        });
    }

    // Extract data loading logic into a separate method (kept for backward compatibility)
    loadEditData(edittarget: string) {
        return this.loadEditDataSafely(edittarget);
    }

    // New method to load survey data
    loadSurveyData(surveyData: any) {
        Object.entries(surveyData.data).forEach((section: any) => {
            const sectionName = section[0]; // 'base', 'details', 'cover', 'shaft'
            const sectionData = section[1];
            
            let targetSection = this.surveySchema.sections.find((s: any) => 
                s.name.replace(/ /g, '').toLowerCase() === sectionName.toLowerCase()
            );
            
            if (targetSection) {
                let attributes = targetSection.sections.find((item: any) => item.name === 'Attributes');
                
                // Process all items to understand structure first
                const sectionItems = Object.entries(sectionData);
                
                // Separate attributes from dynamic sections
                const attributeItems = sectionItems.filter(([key]) => key.includes('attributes'));
                const dynamicItems = sectionItems.filter(([key]) => !key.includes('attributes'));
                
                // Handle attributes first
                attributeItems.forEach(([itemKey, itemValue]) => {
                    if (attributes) {
                                                    Object.entries(itemValue).forEach((field: any) => {
                                const fieldName = field[0];
                                const fieldValue = field[1];
                                
                                // Create field name mapping for common mismatches
                                let targetField = this.findSchemaField(attributes.schema, fieldName);
                                
                                if (targetField) {
                                    // Special handling for client contact
                                    if (targetField.field === 'v-client-contact') {
                                        // Ensure array format for client contact
                                        if (fieldValue && !Array.isArray(fieldValue)) {
                                            targetField.defaultValue = [fieldValue];
                                        } else {
                                            targetField.defaultValue = fieldValue || [];
                                        }
                                    } else {
                                        targetField.defaultValue = fieldValue;
                                    }
                                }
                            });
                        
                        // Update attributes section header after loading all field data
                        this.updateSectionHeaderFromData(attributes, targetSection, 0);
                    }
                });
                
                // Handle dynamic sections (observations, outlets, inlets)
                // Group by type and sort by index
                const { groups: groupedSections, maxIndexes } = this.groupDynamicSections(dynamicItems);
                
                // First, create the required number of sections for each type
                Object.entries(maxIndexes).forEach(([sectionType, maxIndex]: [string, number]) => {
                    if (maxIndex >= 0) {
                        // Count existing sections of this type
                        const existingSections = targetSection.sections.filter((s: any) => s.name === sectionType);
                        const requiredSections = maxIndex + 1; // +1 because indexes are 0-based
                        
                        // Add sections until we have enough
                        for (let i = existingSections.length; i < requiredSections; i++) {
                            this.addSectionCustom(targetSection, sectionType);
                        }
                    }
                });
                
                // Now populate the data for each section
                Object.entries(groupedSections).forEach(([sectionType, items]: [string, any[]]) => {
                    items.forEach((item) => {
                        // Get all sections of this type
                        const availableSections = targetSection.sections.filter((s: any) => s.name === sectionType);
                        const targetSubSection = availableSections[item.index];
                        
                        if (targetSubSection && targetSubSection.schema) {
                            Object.entries(item.data).forEach((field: any) => {
                                const fieldName = field[0];
                                const fieldValue = field[1];
                                
                                let targetField = this.findSchemaField(targetSubSection.schema, fieldName);
                                
                                if (targetField) {
                                    // Special handling for client contact
                                    if (targetField.field === 'v-client-contact') {
                                        // Ensure array format for client contact
                                        if (fieldValue && !Array.isArray(fieldValue)) {
                                            targetField.defaultValue = [fieldValue];
                                        } else {
                                            targetField.defaultValue = fieldValue || [];
                                        }
                                    } else {
                                        targetField.defaultValue = fieldValue;
                                    }
                                }
                            });
                            
                            // Update section header after loading all field data
                            this.updateSectionHeaderFromData(targetSubSection, targetSection, item.index);
                        }
                    });
                });
            }
        });
        
        // Update headers after a short delay to ensure DOM has updated
        setTimeout(() => {
            this.forceHeaderUpdates();
        }, 100);
    }
    
    // Force update all section headers after loading data
    forceHeaderUpdates() {
        // Go through all schema sections and update headers for any that have data
        this.surveySchema.sections.forEach((section: any) => {
            section.sections.forEach((subSection: any, subIndex: number) => {
                if (subSection.schema && subSection.schema.some((field: any) => field.defaultValue)) {
                    this.updateSectionHeaderFromData(subSection, section, subIndex);
                }
            });
        });
    }
    
    // Helper method to update section header from loaded data
    updateSectionHeaderFromData(targetSubSection: any, parentSection: any, sectionIndex: number) {
        if (!targetSubSection || !targetSubSection.schema) return;
        
        // Find fields that should contribute to header display
        const headerFields = targetSubSection.schema.filter((field: any) => {
            return field.defaultValue && field.defaultValue !== '' && field.defaultValue !== null;
        });
        
        // Process fields in order and trigger header updates
        headerFields.forEach((field: any, fieldIndex: number) => {
            let displayValue = field.defaultValue;
            
            // Handle different field types to get proper display values
            if (field.field === 'v-client-contact') {
                // Handle client contact multi-select field
                // Ensure the value is an array for the component
                if (field.defaultValue && !Array.isArray(field.defaultValue)) {
                    // Convert string to array if needed
                    field.defaultValue = [field.defaultValue];
                } else if (!field.defaultValue) {
                    field.defaultValue = [];
                }
                
                // For display in header, join array values with commas
                if (Array.isArray(field.defaultValue) && field.defaultValue.length > 0) {
                    displayValue = field.defaultValue.join(', ');
                } else {
                    displayValue = '';
                }
            } else if (field.field === 'v-tree-select' || field.field === 'v-tree-select-enhanced') {
                // Get the secondary schema for this field
                const secondarySchema = this.filterTreeSelectSchema(parentSection.name, targetSubSection.name, field.label);
                
                if (secondarySchema && secondarySchema.length > 0) {
                    // For tree select fields, look up the display value in secondary schema
                    let foundItem = null;
                    
                    // Search in main items first
                    foundItem = secondarySchema.find((s: any) => s.code === field.defaultValue);
                    
                    // If not found, search in children
                    if (!foundItem) {
                        for (let i = 0; i < secondarySchema.length; i++) {
                            if (secondarySchema[i].children) {
                                foundItem = secondarySchema[i].children.find((child: any) => child.code === field.defaultValue);
                                if (foundItem) {
                                    // For enhanced tree select, format as "parent - child"
                                    if (field.field === 'v-tree-select-enhanced') {
                                        displayValue = secondarySchema[i].description + ' - ' + foundItem.description;
                                    } else {
                                        displayValue = foundItem.description;
                                    }
                                    break;
                                }
                            }
                        }
                    } else {
                        displayValue = foundItem.description;
                    }
                }
            } else if (field.type === 'select' && field.items) {
                // Handle regular select fields
                const selectedItem = field.items.find((item: any) => item.value === field.defaultValue);
                if (selectedItem && selectedItem.text) {
                    displayValue = selectedItem.text;
                }
            }
            // For other field types (text, etc.), use the raw value
            
            // Only emit header update if this field should update the header
            if (field.updateheader) {
                // Create event object that matches the expected format for doCombinedHeader
                const event = {
                    index: fieldIndex.toString(),
                    value: displayValue
                };
                
                // Create props object that matches the expected format
                const props = {
                    index: sectionIndex,
                    item: targetSubSection
                };
                
                // Call the existing header update method
                this.doCombinedHeader(event, parentSection, props);
            }
        });
    }
    
    // Helper method to find schema field by name with flexible matching
    findSchemaField(schema: any[], fieldName: string) {
        // First try direct field matching for lat/lng which are common issues
        if (fieldName === 'lat' || fieldName === 'latitude') {
            const latField = schema.find((s: any) => 
                s.label && (s.label.toLowerCase().includes('latitude') || s.label.toLowerCase() === 'lat')
            );
            if (latField) return latField;
        }
        
        if (fieldName === 'lng' || fieldName === 'longitude') {
            const lngField = schema.find((s: any) => 
                s.label && (s.label.toLowerCase().includes('longitude') || s.label.toLowerCase() === 'lng')
            );
            if (lngField) return lngField;
        }
        
        // Create a mapping of common field name variations
        const fieldMappings: {[key: string]: string[]} = {
            'lat': ['latitude', 'lat'],
            'lng': ['longitude', 'lng'],
            'assetNo': ['asset no', 'assetno', 'asset number'],
            'clientContact': ['client contact', 'clientcontact'],
            'projectReference': ['project reference', 'projectreference'],
            'inspectionPurpose': ['inspection purpose', 'inspectionpurpose'],
            'clockPosition': ['clock position', 'clockposition'],
            'depthToInvertM': ['depth to invert m', 'depthtoinvertm', 'depth to invert (m)'],
            'pipeMaterial': ['pipe material', 'pipematerial'],
            'benchingMaterial': ['benching material', 'benchingmaterial'],
            'channelMaterial': ['channel material', 'channelmaterial'],
            'shapeOfShaft': ['shape of shaft', 'shapeofshaft'],
            'wallMaterial': ['wall material', 'wallmaterial'],
            'typeOfSteps': ['type of steps', 'typeofsteps'],
            'materialOfSteps': ['material of steps', 'materialofsteps'],
            'locatedStatus': ['located status', 'locatedstatus'],
            'locationType': ['location type', 'locationtype'],
            'nodeType': ['node type', 'nodetype'],
            'flowControl': ['flow control', 'flowcontrol']
        };
        
        const normalizedFieldName = fieldName.toLowerCase().replace(/ /g, '').replace(/\(/g, '').replace(/\)/g, '');
        
        return schema.find((s: any) => {
            const normalizedLabel = s.label.toLowerCase().replace(/ /g, '').replace(/\(/g, '').replace(/\)/g, '');
            
            // Direct match
            if (normalizedLabel === normalizedFieldName) {
                return true;
            }
            
            // Check mappings
            const mappings = fieldMappings[fieldName];
            if (mappings) {
                return mappings.some(mapping => 
                    normalizedLabel === mapping.replace(/ /g, '').replace(/\(/g, '').replace(/\)/g, '')
                );
            }
            
            // Fallback: check if field name contains label or vice versa
            return normalizedLabel.includes(normalizedFieldName) || normalizedFieldName.includes(normalizedLabel);
        });
    }
    
    // Helper method to group and sort dynamic sections
    groupDynamicSections(dynamicItems: [string, any][]) {
        const groups: {[key: string]: any[]} = {
            'Observation': [],
            'Outlet': [],
            'Inlet': []
        };
        
        const maxIndexes: {[key: string]: number} = {
            'Observation': -1,
            'Outlet': -1,
            'Inlet': -1
        };
        
        dynamicItems.forEach(([itemKey, itemValue]) => {
            let sectionType = null;
            let index = 0;
            
            if (itemKey.includes('observation')) {
                sectionType = 'Observation';
                // Extract index from 'observation1', 'observation0', etc.
                const match = itemKey.match(/observation(\d+)/);
                index = match ? parseInt(match[1]) : 0;
            } else if (itemKey.includes('outlet')) {
                sectionType = 'Outlet';
                const match = itemKey.match(/outlet(\d+)/);
                index = match ? parseInt(match[1]) : 0;
            } else if (itemKey.includes('inlet')) {
                sectionType = 'Inlet';
                const match = itemKey.match(/inlet(\d+)/);
                index = match ? parseInt(match[1]) : 0;
            }
            
            if (sectionType) {
                maxIndexes[sectionType] = Math.max(maxIndexes[sectionType], index);
                groups[sectionType].push({
                    originalKey: itemKey,
                    index: index,
                    data: itemValue
                });
            }
        });
        
        // Sort each group by index to maintain proper order
        Object.keys(groups).forEach(key => {
            groups[key].sort((a, b) => a.index - b.index);
        });
        
        return { groups, maxIndexes };
    }

    // New method to load survey files
    loadSurveyFiles(filesData: any) {
        let dropzoneChecker = setInterval(() => {
            const vdropzone: any = this.$refs.vdropzone as Vue;
            if (vdropzone !== undefined) {
                clearInterval(dropzoneChecker);
                filesData.forEach((file: any, index: number) => {
                    // Check if the file has actual content
                    if (file.size > 0) {
                        try {
                            // Try to read the file content to create a proper preview
                            const reader = new FileReader();
                            reader.onload = (e: any) => {
                                try {
                                    // Create a new file from the read data
                                    if (!e.target || !e.target.result) {
                                        this.fallbackFileHandling(file, vdropzone);
                                        return;
                                    }
                                    
                                    const arrayBuffer = e.target.result as ArrayBuffer;
                                    const blob = new Blob([arrayBuffer], { type: file.type });
                                    
                                    const newFile = new File([blob], file.name, {
                                        type: file.type,
                                        lastModified: file.lastModified || Date.now()
                                    });
                                    
                                    // Add to our file data array
                                    this.fileData.push(newFile);
                                    
                                    // Create preview URL for images/videos
                                    if (file.type && (file.type.startsWith('image/') || file.type.startsWith('video/'))) {
                                        const previewUrl = URL.createObjectURL(blob);
                                        // Add preview URL property that dropzone can use
                                        Object.defineProperty(newFile, 'dataURL', {
                                            value: previewUrl,
                                            writable: false
                                        });
                                    }
                                    
                                    // Add to dropzone
                                    vdropzone.enqueueFile(newFile);
                                    this.fileCount++;
                                } catch (error) {
                                    this.fallbackFileHandling(file, vdropzone);
                                }
                            };
                            
                            reader.onerror = () => {
                                this.fallbackFileHandling(file, vdropzone);
                            };
                            
                            reader.onabort = () => {
                                this.fallbackFileHandling(file, vdropzone);
                            };

                            // Try to read the file as ArrayBuffer
                            reader.readAsArrayBuffer(file);
                            
                        } catch (error) {
                            this.fallbackFileHandling(file, vdropzone);
                        }
                    } else {
                        this.fallbackFileHandling(file, vdropzone);
                    }
                });
            }
        }, 100);
        
        // Clear interval after 5 seconds as fallback
        setTimeout(() => {
            clearInterval(dropzoneChecker);
        }, 5000);
    }

    // Fallback method for when file reading fails
    fallbackFileHandling(file: any, vdropzone: any) {
        // Just add the file as-is, even if preview won't work
        this.fileData.push(file);
        vdropzone.enqueueFile(file);
        this.fileCount++;
    }

    // New method to initialize fresh schema
    initializeFreshSchema() {
        // Guard against undefined surveySchema
        if (!this.surveySchema || !this.surveySchema.sections) {
            return;
        }
        
        this.surveySchema.sections.forEach((section: any) => {
            section.sections.forEach((subsection: any) => {
                subsection.alternateKey = uuid();
                subsection.schema.forEach((field: any) => {
                    if (field.label !== 'Clock Position') {
                        field.defaultValue = '';
                    }
                });
            });
        });
    }

    beforeDestroy() {
        // Reset component state
        this.fileData = [];
        this.fileCount = 0;
        this.pendingFiles = [];
        this.headerValues = {};
        this.dirty = false;
        this.isMounted = false;

        // Clear the survey schema properly
        if (this.surveySchema && this.surveySchema.sections) {
            this.surveySchema.sections.forEach((s: any) => {
                let names: any = {}
                let indexsForRemoval: Array<number> = []

                s.sections.forEach((sec: any, idx: number) => {
                    // Reset section values
                    sec.value = ''
                    
                    // Reset all schema field default values
                    if (sec.schema) {
                        sec.schema.forEach((field: any) => {
                            if (field.label !== 'Clock Position') {
                                field.defaultValue = '';
                            }
                        });
                    }

                    if (names[sec.name] === undefined) {
                        names[sec.name] = true
                    } else {
                        indexsForRemoval.push(idx)
                    }
                })

                indexsForRemoval.reverse().forEach((idx: number) => {
                    s.sections.splice(idx, 1)
                })
            })
        }

        modules.root.showFab()
        modules.browser.geolocationClearWatch()
    }

    get uniqueId() {
        return uuid()
    }

    get sections() {
        return this.surveySchema.sections
    }

    get dynamicProps() {
        let total: any = {}

        this.sections.forEach((element: any) => total[element.name] = countBy(element.sections, 'name'))

        return total
    }

    filterTreeSelectSchema(featureName: string, typeName: string, fieldName: string) {
        return this.surveySchema.treeSelectSchema.filter(({ feature, type, field }: any) =>
            feature === featureName && type === typeName && field === fieldName
        )
    }

    getIndexForSection(section: any, props: any) {
      /*
        We are trying to find which occurrence of this type within the existing panel
        Loop from the first section, up to the current section.
        Each time we find a section named the same as the desired section,
        increment the counter.

        Given we are only looping up to the desired index, we should never
        drop out the bottom of the for loop.
      */

      let index=0;
      for (let i=0;i<section.sections.length;i++) {
        if (section.sections[i].name === props.item.name) {
          if (i === props.index) {
              return index;
          }

          index++;
        }
      }

      throw "Could not find index for section";
    }

    getCountForSection(section: any, props: any) {
      let index=0;
      for (let i=0;i<section.sections.length;i++) {
        if (section.sections[i].name === props.item.name) {
          index++;
        }
      }

      return index;
    }

    addSectionCustom(section: any, sectionName: any) {
        let index = 0,
            ObservationCount = 0,
            InletCount = 0,
            OutletCount = 0;

        let propsArray = {};

        if( section.name == 'Base' ) {
            let sectionIndex = 0;
            if( sectionName == 'Outlet' ) {
                for (let i=0;i<section.sections.length;i++) {
                    if (section.sections[i].name === 'Outlet') {
                        index++;
                    }
                }
            }
            if( sectionName == 'Inlet' ) {
                for (let i=0;i<section.sections.length;i++) {
                    if (section.sections[i].name === 'Outlet') {
                        index++;
                    }
                }
                for (let i=0;i<section.sections.length;i++) {
                    if (section.sections[i].name === 'Inlet') {
                        sectionIndex++;
                    }
                }
            }
            if( sectionName == 'Observation' ) {
                for (let i=0;i<section.sections.length;i++) {
                    if (section.sections[i].name === 'Outlet' || section.sections[i].name === 'Inlet') {
                        index++;
                    }
                }
                for (let i=0;i<section.sections.length;i++) {
                    if (section.sections[i].name === 'Observation') {
                        sectionIndex++;
                    }
                }
            }
            index += sectionIndex;
            propsArray = {
                index: index,
                item: section.sections[index]
            }
        } else {
            for (let i=0;i<section.sections.length;i++) {
                if (section.sections[i].name === sectionName) {
                    index++;
                }
            }
            propsArray = {
                index: index,
                item: section.sections[index]
            }
        }

        this.addSection(section, propsArray);
    }

    addSection(section: any, props: any) {
      /* Declare "var g_this, g_modules, g_section, g_props" in console.
        g_this = this
        g_modules = modules
        g_section = section
        g_props = props
        */


        let expansion_panel_index = 0;
        for(let i=0;i<this.sections.length;i++) {
          if (this.sections[i].name === section.name) {
            expansion_panel_index = i;
            break;
          }
        }

        let index = this.getIndexForSection(section, props)
        let new_index = index + 1
        let count = this.getCountForSection(section, props)
        if( count < 9 ) {
            let mv = modules.survey;
            if (mv.data[this.uniqueId]) {
              if (mv.data[this.uniqueId][camelCase(section.name)] === undefined) {
                mv.data[this.uniqueId][camelCase(section.name)] = {}
              }
              let obj = mv.data[this.uniqueId][camelCase(section.name)]
              for (let i=count;i>new_index;i--) {
                obj[camelCase(props.item.name + i)] = obj[camelCase(props.item.name + (i-1))]
              }
              obj[camelCase(props.item.name + new_index)] = {}
            }

            let clone = JSON.parse(JSON.stringify(props.item))
            clone.value = ''
            clone.alternateKey = uuid()
            clone.class = 'inserted';
            
            // Reset all schema field default values to ensure blank form
            if (clone.schema) {
                clone.schema.forEach((field: any) => {
                    if (field.label !== 'Clock Position') {
                        field.defaultValue = '';
                    }
                });
            }
            section.sections.splice(props.index + 1, 0, clone);

            // Open the new clone
            setTimeout(() => {
              let base = document.querySelectorAll('ul.v-expansion-panel')[expansion_panel_index]
              let li = base.querySelectorAll('li')[props.index + 1]
              if (li !== null) {
                // @ts-ignore - Without this, generates a "variable could be null error"
                li.querySelector('div').click()
              }
            }, 200)
        }
    }

    clearSection(section: any, props: any) {
        let index = this.getIndexForSection(section, props)
        let count = this.getCountForSection(section, props)

        // If we are inserting rather than appending, then make space to store
        let mv = modules.survey
        let obj = mv.data[this.uniqueId][camelCase(section.name)]
        for (let i=index;i<count-1;i++) {
          obj[camelCase(props.item.name + i)] = obj[camelCase(props.item.name + (i+1))]
        }
        delete obj[camelCase(props.item.name + (count - 1))]
        section.sections.splice(props.index, 1)
    }

    // this if called everytime a form value changes
    storeSection(value: any, section: any, props: any, schema: any) {
        let index = this.getIndexForSection(section, props)
        let panelName = props.item.name + index

        if(value === null) {
            // unset it
            modules.survey.store({
                [this.uniqueId]: {
                    [camelCase(section.name)]: {
                        [camelCase(panelName)]: {
                            [camelCase(schema.label)]: null // the store() function uses lodash merge - which doesn't do what you think it does, and will ignore 'undefined' values. So we'll set it to null here.
                        }
                    }
                }
            })

        } else {
            // Special handling for array fields (like client contact) to prevent lodash merge from merging arrays
            if (Array.isArray(value) && schema.label && schema.label.toLowerCase().includes('client contact')) {
                // For client contact arrays, clear the field first, then set the new value
                modules.survey.store({
                    [this.uniqueId]: {
                        [camelCase(section.name)]: {
                            [camelCase(panelName)]: {
                                [camelCase(schema.label)]: null
                            }
                        }
                    }
                })
                // Then set the new value in the next tick to ensure replacement
                this.$nextTick(() => {
                    modules.survey.store({
                        [this.uniqueId]: {
                            [camelCase(section.name)]: {
                                [camelCase(panelName)]: {
                                    [camelCase(schema.label)]: value
                                }
                            }
                        }
                    })
                })
            } else {
                // just store it for non-array fields
                modules.survey.store({
                    [this.uniqueId]: {
                        [camelCase(section.name)]: {
                            [camelCase(panelName)]: {
                                [camelCase(schema.label)]: value
                            }
                        }
                    }
                })
            }
        }
    }

    saveFiles(title: string, text: string) {

        modules.files.process(this.uniqueId)

        return modules.root.actionAlert({
            title: title,
            text: text,
            destination: this.parentPage
        })
    }

    processForm() {
        this.$validator.validate()
            .then(async (result: any) => {

                if (!result) {

                    this.expand = 0

                    return modules.root.snackbar('Check required fields')
                }

                if (window.confirm('Are you sure you want to Submit?') === false) {
                    return;
                }

                this.dirty = false;
                window.onbeforeunload = null

                const vdropzone: any = this.$refs.vdropzone as Vue

                if( vdropzone.getQueuedFiles() ) {
                  vdropzone.getQueuedFiles().forEach((item: any, index: any) => {
                    let fileArray:any = {};
                    for( var k in item ) {
                      fileArray[k] = item[k];
                    }
                    let myNewFile = new File([item], this.fileCount+'_'+item.name, {type: item.type});

                    this.fileData.push(myNewFile);
                    this.fileCount++;
                  });
                }

                modules.files.store({
                    uniqueId: this.uniqueId,
                    files: this.fileData
                })

                modules.survey.process(this.uniqueId);

                // Handle editing scenario - clean up old data
                const edittarget = this.$route.query.uuid as string;
                if (edittarget && edittarget !== this.uniqueId) {
                  // Remove the old survey data since we're creating a new entry
                  localForage.surveys.removeItem(edittarget);
                  localForage.files.removeItem(edittarget);
                  localForage.referencenumbers.removeItem(edittarget);
                }

                return this.saveFiles('Added to queue', 'Your survey has been queued for upload.')

                // if (!await isOnline()) {

                //     return this.saveFiles('No connection detected', 'Your survey has been queued for upload.')
                // }

                // eslint-disable-next-line
                modules.root.loadingAlert('Processing survey')

                new Survey(this.$http).post(await localForage.getSurveyItem(this.uniqueId))
                    .then(async (response: any) => {

                        localForage.referencenumbers.setItem(this.uniqueId, response.data.referenceNo)

                        if (!modules.files.data[this.uniqueId].length) return

                        const upload = new Upload(this.$http, this.uniqueId, response.data.referenceNo)

                        // await upload.createAccessToken()
                        // await upload.createParentFolder(modules.user.customerDetail.driveId)

                        modules.root.createCancelToken()
                        await upload.getClientIds(modules.user.customerDetail.code, modules.user.userDetail.email, modules.root.cancelSource.token, response.data.referenceNo, this.uniqueId)
                        for (const item of modules.files.data[this.uniqueId]) {
                            // await upload.storeItem(item)
                            await upload.storeSurveyItem(item, response.data.referenceNo, '')
                        }
                    })
                    .then((response: any) => {
                        localForage.surveys.removeItem(this.uniqueId)
                        localForage.referencenumbers.removeItem(this.uniqueId)

                        this.dirty = false

                        modules.root.actionAlert({
                            title: 'Survey submitted',
                            text: 'Your survey was successfully submitted.',
                            destination: this.parentPage
                        })
                    })
                    .catch(async (error: any) => {

                        const referenceNumber = await localForage.getReferenceNumberItem(this.uniqueId)

                        return this.saveFiles('An error occured', `Your survey has been queued for upload. ${ referenceNumber !== null ? `Reference: ${ referenceNumber }` : '' }`)
                    })
            })
    }

    // CONTINUE FROM HERE SOO
    checkFile(file: any) {
        const vdropzone: any = this.$refs.vdropzone as Vue
        if( this.countValidFiles(this.pendingFiles) < 5 ) {
            let fileData = {
                'file': file,
                'title': file.name,
                'subtitle': file.size,
                'lastModified': file.lastModified,
                'progress': 100,
                'isInvalid': false,
                'uploaded': true
            }
            if( !this.isValidFileType(file.name, 'image') &&
                !this.isValidFileType(file.name, 'video') ) {
                fileData.isInvalid = true;
                vdropzone.removeFile(file);
            } else {
                if( this.isFileExist(this.pendingFiles, file) ) {
                    vdropzone.removeFile(file);
                } else {
                    this.pendingFiles.push(fileData);
                }
            }
        } else {
            vdropzone.removeFile(file);
        }
    }
    checkFiles(file: any) {
    }
    fileRemoved(file: any) {
    }
    removeFile(item:any, index: any) {
        const vdropzone: any = this.$refs.vdropzone as Vue
        vdropzone.removeFile(item.file);
        this.pendingFiles.splice(index, 1);
        this.fileData.splice(index, 1);
        this.fileCount--;
    }

    async invalidFileUpload() {
      await this.$http.get(`${ process.env.VUE_APP_DOT_NET_API_BASE_URL }${ process.env.VUE_APP_DOT_NET_API_CLIENT_V3_DETAILS }/${ modules.user.userDetail.email }`)
          .then(async (response: any) => {

              await this.$http.post(process.env.VUE_APP_V3_CCTV_UPLOAD_INVALID, {
                  // fieldData: this.fieldData,
                  id: response.data[0].id,
                  reticIds: this.ids,
                  invalidTotal: countBy(this.invalidFiles, flow(method('title.replace', /^.*\./, '') as any)),
                  duplicateTotal: countBy(this.duplicateFiles, flow(method('title.replace', /^.*\./, '') as any)),
              }, {
                  headers: {
                      Authorization: process.env.VUE_APP_V3_API_KEY
                  }
              })
              .then(response => {})
          })
          .catch((error: any) => {})
    }

    extensionLists: Array<any> = [{
      video: ['yuv', 'wmv', 'webm', 'vob', 'svi', 'roq', 'rmvb', 'rm', 'ogv', 'ogg', 'nsv', 'mxf', 'mts', 'm2ts', 'ts', 'mpg', 'mpeg', 'm2v', 'mp2', 'mpe', 'mpv', 'mp4', 'm4p', 'm4v', 'mov', 'qt', 'mng', 'mkv', 'gifv', 'gif', 'flv' ,'f4v', 'f4p', 'f4a', 'f4b', 'flv', 'drc', 'avi', 'asf', 'amv', '3gp', '3g2', 'bup', 'ifo'],
      data: ['csv', 'dat', 'db', 'dbf', 'log', 'mdb', 'sav', 'sql', 'tar', 'xml', 'sdf', 'xls', 'xlsx', 'xlsm', 'xlsb', 'html', 'xltx', 'xltm'],
      report: ['ani', 'anim', 'apng', 'art', 'bmp', 'bpg', 'bsave', 'cal', 'cin', 'cpc', 'cpt', 'dds', 'dpx', 'ecw', 'exr', 'fits', 'flic', 'flif', 'fpx', 'gif', 'hdri', 'hevc', 'icer', 'icns', 'ico', 'cur', 'ics', 'ilbm', 'jbig', 'jbig2', 'jng', 'jpeg', 'jpeg-ls', 'jpeg 2000', 'jpeg xr', 'jpeg xtt', 'jpeg-hdr', 'kra', 'mng', 'miff', 'nrrd', 'pam', 'pbm', 'pgm', 'ppm', 'pnm', 'pcx', 'pgf', 'pictor', 'jpg', 'png', 'psd', 'psb', 'psp', 'qtvr', 'ras' ,'rgbe', 'tiff', 'sgi', 'tga', 'ufo', 'ufp', 'wbmp', 'webp', 'xbm', 'xcf', 'xpm', 'xwd', 'ciff', 'dng', 'ai', 'cdr', 'cgm', 'dxf', 'eva', 'emf', 'gerber', 'emf+', 'hvif', 'iges', 'pgml', 'svg', 'vml', 'wmf', 'xar', 'cdf', 'djvu', 'eps', 'pdf', 'pict', 'ps', 'swf', 'xaml'],
      plan: ['ani', 'anim', 'apng', 'art', 'bmp', 'bpg', 'bsave', 'cal', 'cin', 'cpc', 'cpt', 'dds', 'dpx', 'ecw', 'exr', 'fits', 'flic', 'flif', 'fpx', 'gif', 'hdri', 'hevc', 'icer', 'icns', 'ico', 'cur', 'ics', 'ilbm', 'jbig', 'jbig2', 'jng', 'jpeg', 'jpeg-ls', 'jpeg 2000', 'jpeg xr', 'jpeg xtt', 'jpeg-hdr', 'kra', 'mng', 'miff', 'nrrd', 'pam', 'pbm', 'pgm', 'ppm', 'pnm', 'pcx', 'pgf', 'pictor', 'jpg', 'png', 'psd', 'psb', 'psp', 'qtvr', 'ras' ,'rgbe', 'tiff', 'sgi', 'tga', 'ufo', 'ufp', 'wbmp', 'webp', 'xbm', 'xcf', 'xpm', 'xwd', 'ciff', 'dng', 'ai', 'cdr', 'cgm', 'dxf', 'eva', 'emf', 'gerber', 'emf+', 'hvif', 'iges', 'pgml', 'svg', 'vml', 'wmf', 'xar', 'cdf', 'djvu', 'eps', 'pdf', 'pict', 'ps', 'swf', 'xaml'],
      image: ['ani', 'anim', 'apng', 'art', 'bmp', 'bpg', 'bsave', 'cal', 'cin', 'cpc', 'cpt', 'dds', 'dpx', 'ecw', 'exr', 'fits', 'flic', 'flif', 'fpx', 'gif', 'hdri', 'hevc', 'icer', 'icns', 'ico', 'cur', 'ics', 'ilbm', 'jbig', 'jbig2', 'jng', 'jpeg', 'jpeg-ls', 'jpeg 2000', 'jpeg xr', 'jpeg xtt', 'jpeg-hdr', 'kra', 'mng', 'miff', 'nrrd', 'pam', 'pbm', 'pgm', 'ppm', 'pnm', 'pcx', 'pgf', 'pictor', 'jpg', 'png', 'psd', 'psb', 'psp', 'qtvr', 'ras' ,'rgbe', 'tiff', 'sgi', 'tga', 'ufo', 'ufp', 'wbmp', 'webp', 'xbm', 'xcf', 'xpm', 'xwd', 'ciff', 'dng', 'ai', 'cdr', 'cgm', 'dxf', 'eva', 'emf', 'gerber', 'emf+', 'hvif', 'iges', 'pgml', 'svg', 'vml', 'wmf', 'xar', 'cdf', 'djvu', 'eps', 'pdf', 'pict', 'ps', 'swf', 'xaml'],
      zip: ['zip']
    }]
    isValidFileType(fName:any, fType:any) {
        return this.extensionLists[0][fType].indexOf(fName.toLowerCase().split('.').pop()) > -1;
    }

    isFileExist(arr:any, item:any) {
      let hasResult = false;
      arr.find((o:any, i:number) => {
        if( o.uploaded && o.title == item.name && o.subtitle == item.size && o.lastModified == item.lastModified ) {
          hasResult = true;
        }
      });
      return hasResult;
    }
    countValidFiles(arr:any) {
      let co = 0;
      arr.find((o:any, i:number) => {
        if( !o.isInvalid ) {
          co++
        }
      });
      return co;
    }
    formatsize(filesize: any) {
        var thresh = 1000;
        if(Math.abs(filesize) < thresh) {
            return filesize + ' B';
        }
        var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
        var u = -1;
        do {
            filesize /= thresh;
            ++u;
        } while(Math.abs(filesize) >= thresh && u < units.length - 1);
        return filesize.toFixed(1)+' '+units[u];
        // return fileSize(filesize).human()
    }
}
